// This file is autogenerated by scraper.ts
  import Wild_HorseradishImg from "./img/Wild_Horseradish.png";
import DaffodilImg from "./img/Daffodil.png";
import LeekImg from "./img/Leek.png";
import DandelionImg from "./img/Dandelion.png";
import ParsnipImg from "./img/Parsnip.png";
import Cave_CarrotImg from "./img/Cave_Carrot.png";
import CoconutImg from "./img/Coconut.png";
import Cactus_FruitImg from "./img/Cactus_Fruit.png";
import BananaImg from "./img/Banana.png";
import SapImg from "./img/Sap.png";
import Large_EggImg from "./img/Large_Egg.png";
import EggImg from "./img/Egg.png";
import Brown_EggImg from "./img/Brown_Egg.png";
import Large_Brown_EggImg from "./img/Large_Brown_Egg.png";
import MilkImg from "./img/Milk.png";
import Large_MilkImg from "./img/Large_Milk.png";
import Green_BeanImg from "./img/Green_Bean.png";
import CauliflowerImg from "./img/Cauliflower.png";
import PotatoImg from "./img/Potato.png";
import GarlicImg from "./img/Garlic.png";
import KaleImg from "./img/Kale.png";
import RhubarbImg from "./img/Rhubarb.png";
import MelonImg from "./img/Melon.png";
import TomatoImg from "./img/Tomato.png";
import MorelImg from "./img/Morel.png";
import BlueberryImg from "./img/Blueberry.png";
import Fiddlehead_FernImg from "./img/Fiddlehead_Fern.png";
import Hot_PepperImg from "./img/Hot_Pepper.png";
import WheatImg from "./img/Wheat.png";
import RadishImg from "./img/Radish.png";
import Red_CabbageImg from "./img/Red_Cabbage.png";
import StarfruitImg from "./img/Starfruit.png";
import CornImg from "./img/Corn.png";
import Unmilled_RiceImg from "./img/Unmilled_Rice.png";
import EggplantImg from "./img/Eggplant.png";
import ArtichokeImg from "./img/Artichoke.png";
import PumpkinImg from "./img/Pumpkin.png";
import Bok_ChoyImg from "./img/Bok_Choy.png";
import YamImg from "./img/Yam.png";
import ChanterelleImg from "./img/Chanterelle.png";
import CranberriesImg from "./img/Cranberries.png";
import HollyImg from "./img/Holly.png";
import BeetImg from "./img/Beet.png";
import Ostrich_EggImg from "./img/Ostrich_Egg.png";
import SalmonberryImg from "./img/Salmonberry.png";
import AmaranthImg from "./img/Amaranth.png";
import Pale_AleImg from "./img/Pale_Ale.png";
import HopsImg from "./img/Hops.png";
import Void_EggImg from "./img/Void_Egg.png";
import MayonnaiseImg from "./img/Mayonnaise.png";
import Duck_MayonnaiseImg from "./img/Duck_Mayonnaise.png";
import Void_MayonnaiseImg from "./img/Void_Mayonnaise.png";
import ClayImg from "./img/Clay.png";
import Copper_BarImg from "./img/Copper_Bar.png";
import Iron_BarImg from "./img/Iron_Bar.png";
import Gold_BarImg from "./img/Gold_Bar.png";
import Iridium_BarImg from "./img/Iridium_Bar.png";
import Refined_QuartzImg from "./img/Refined_Quartz.png";
import HoneyImg from "./img/Honey.png";
import PicklesImg from "./img/Pickles.png";
import JellyImg from "./img/Jelly.png";
import BeerImg from "./img/Beer.png";
import WineImg from "./img/Wine.png";
import JuiceImg from "./img/Juice.png";
import ClamImg from "./img/Clam.png";
import PoppyImg from "./img/Poppy.png";
import Copper_OreImg from "./img/Copper_Ore.png";
import Iron_OreImg from "./img/Iron_Ore.png";
import CoalImg from "./img/Coal.png";
import Gold_OreImg from "./img/Gold_Ore.png";
import Iridium_OreImg from "./img/Iridium_Ore.png";
import WoodImg from "./img/Wood.png";
import StoneImg from "./img/Stone.png";
import Nautilus_ShellImg from "./img/Nautilus_Shell.png";
import CoralImg from "./img/Coral.png";
import Rainbow_ShellImg from "./img/Rainbow_Shell.png";
import Spice_BerryImg from "./img/Spice_Berry.png";
import Sea_UrchinImg from "./img/Sea_Urchin.png";
import GrapeImg from "./img/Grape.png";
import Spring_OnionImg from "./img/Spring_Onion.png";
import StrawberryImg from "./img/Strawberry.png";
import Sweet_PeaImg from "./img/Sweet_Pea.png";
import Common_MushroomImg from "./img/Common_Mushroom.png";
import Wild_PlumImg from "./img/Wild_Plum.png";
import HazelnutImg from "./img/Hazelnut.png";
import BlackberryImg from "./img/Blackberry.png";
import Winter_RootImg from "./img/Winter_Root.png";
import Crystal_FruitImg from "./img/Crystal_Fruit.png";
import Snow_YamImg from "./img/Snow_Yam.png";
import Sweet_Gem_BerryImg from "./img/Sweet_Gem_Berry.png";
import CrocusImg from "./img/Crocus.png";
import Red_MushroomImg from "./img/Red_Mushroom.png";
import SunflowerImg from "./img/Sunflower.png";
import Purple_MushroomImg from "./img/Purple_Mushroom.png";
import CheeseImg from "./img/Cheese.png";
import Goat_CheeseImg from "./img/Goat_Cheese.png";
import ClothImg from "./img/Cloth.png";
import TruffleImg from "./img/Truffle.png";
import Truffle_OilImg from "./img/Truffle_Oil.png";
import Coffee_BeanImg from "./img/Coffee_Bean.png";
import Goat_MilkImg from "./img/Goat_Milk.png";
import Large_Goat_MilkImg from "./img/Large_Goat_Milk.png";
import WoolImg from "./img/Wool.png";
import Duck_EggImg from "./img/Duck_Egg.png";
import Duck_FeatherImg from "./img/Duck_Feather.png";
import CaviarImg from "./img/Caviar.png";
import Rabbits_FootImg from "./img/Rabbit's_Foot.png";
import Aged_RoeImg from "./img/Aged_Roe.png";
import Ancient_FruitImg from "./img/Ancient_Fruit.png";
import MeadImg from "./img/Mead.png";
import TulipImg from "./img/Tulip.png";
import Summer_SpangleImg from "./img/Summer_Spangle.png";
import Fairy_RoseImg from "./img/Fairy_Rose.png";
import Blue_JazzImg from "./img/Blue_Jazz.png";
import AppleImg from "./img/Apple.png";
import Green_TeaImg from "./img/Green_Tea.png";
import ApricotImg from "./img/Apricot.png";
import OrangeImg from "./img/Orange.png";
import PeachImg from "./img/Peach.png";
import PomegranateImg from "./img/Pomegranate.png";
import CherryImg from "./img/Cherry.png";
import Bug_MeatImg from "./img/Bug_Meat.png";
import HardwoodImg from "./img/Hardwood.png";
import Maple_SyrupImg from "./img/Maple_Syrup.png";
import Oak_ResinImg from "./img/Oak_Resin.png";
import Pine_TarImg from "./img/Pine_Tar.png";
import SlimeImg from "./img/Slime.png";
import Bat_WingImg from "./img/Bat_Wing.png";
import Solar_EssenceImg from "./img/Solar_Essence.png";
import Void_EssenceImg from "./img/Void_Essence.png";
import FiberImg from "./img/Fiber.png";
import Battery_PackImg from "./img/Battery_Pack.png";
import Dinosaur_MayonnaiseImg from "./img/Dinosaur_Mayonnaise.png";
import RoeImg from "./img/Roe.png";
import Squid_InkImg from "./img/Squid_Ink.png";
import Tea_LeavesImg from "./img/Tea_Leaves.png";
import GingerImg from "./img/Ginger.png";
import Taro_RootImg from "./img/Taro_Root.png";
import PineappleImg from "./img/Pineapple.png";
import MangoImg from "./img/Mango.png";
import Cinder_ShardImg from "./img/Cinder_Shard.png";
import Magma_CapImg from "./img/Magma_Cap.png";
import Bone_FragmentImg from "./img/Bone_Fragment.png";
import Radioactive_OreImg from "./img/Radioactive_Ore.png";
import Radioactive_BarImg from "./img/Radioactive_Bar.png";
  export const ShippingItems = [
    {Name: "Wild Horseradish", Image: Wild_HorseradishImg, Seasons: ["Spring"], Sources: ["Foraging","Spring Seeds","Foraging"]}
  ,{Name: "Daffodil", Image: DaffodilImg, Seasons: ["Spring"], Sources: ["Foraging","Spring Seeds","Foraging"]}
  ,{Name: "Leek", Image: LeekImg, Seasons: ["Spring"], Sources: ["Foraging","Spring Seeds","Foraging"]}
  ,{Name: "Dandelion", Image: DandelionImg, Seasons: ["Spring"], Sources: ["Foraging","Spring Seeds","Flower Dance","Foraging"]}
  ,{Name: "Parsnip", Image: ParsnipImg, Seasons: ["Spring"], Sources: ["Farming"]}
  ,{Name: "Cave Carrot", Image: Cave_CarrotImg, Seasons: [], Sources: ["Foraging","Foraging"]}
  ,{Name: "Coconut", Image: CoconutImg, Seasons: [], Sources: ["Foraging"]}
  ,{Name: "Cactus Fruit", Image: Cactus_FruitImg, Seasons: [], Sources: ["Foraging"]}
  ,{Name: "Banana", Image: BananaImg, Seasons: ["Summer"], Sources: ["Banana Tree","Farming"]}
  ,{Name: "Sap", Image: SapImg, Seasons: [], Sources: ["Trees","Slimes","Foraging"]}
  ,{Name: "Large Egg", Image: Large_EggImg, Seasons: [], Sources: ["Chicken"]}
  ,{Name: "Egg", Image: EggImg, Seasons: [], Sources: ["Chicken"]}
  ,{Name: "Brown Egg", Image: Brown_EggImg, Seasons: [], Sources: []}
  ,{Name: "Large Brown Egg", Image: Large_Brown_EggImg, Seasons: [], Sources: []}
  ,{Name: "Milk", Image: MilkImg, Seasons: [], Sources: ["Cow"]}
  ,{Name: "Large Milk", Image: Large_MilkImg, Seasons: [], Sources: ["Cow"]}
  ,{Name: "Green Bean", Image: Green_BeanImg, Seasons: ["Spring"], Sources: ["Farming"]}
  ,{Name: "Cauliflower", Image: CauliflowerImg, Seasons: ["Spring"], Sources: ["Farming"]}
  ,{Name: "Potato", Image: PotatoImg, Seasons: ["Spring"], Sources: ["Farming"]}
  ,{Name: "Garlic", Image: GarlicImg, Seasons: ["Spring"], Sources: ["Farming"]}
  ,{Name: "Kale", Image: KaleImg, Seasons: ["Spring"], Sources: ["Farming"]}
  ,{Name: "Rhubarb", Image: RhubarbImg, Seasons: ["Spring"], Sources: ["Farming"]}
  ,{Name: "Melon", Image: MelonImg, Seasons: ["Summer"], Sources: ["Farming"]}
  ,{Name: "Tomato", Image: TomatoImg, Seasons: ["Summer"], Sources: ["Farming"]}
  ,{Name: "Morel", Image: MorelImg, Seasons: ["Spring"], Sources: ["Foraging","Foraging"]}
  ,{Name: "Blueberry", Image: BlueberryImg, Seasons: ["Summer"], Sources: ["Farming"]}
  ,{Name: "Fiddlehead Fern", Image: Fiddlehead_FernImg, Seasons: ["Summer"], Sources: ["Foraging","Foraging"]}
  ,{Name: "Hot Pepper", Image: Hot_PepperImg, Seasons: ["Summer"], Sources: ["Farming"]}
  ,{Name: "Wheat", Image: WheatImg, Seasons: ["Summer","Fall"], Sources: ["Farming"]}
  ,{Name: "Radish", Image: RadishImg, Seasons: ["Summer"], Sources: ["Farming"]}
  ,{Name: "Red Cabbage", Image: Red_CabbageImg, Seasons: ["Summer"], Sources: ["Farming"]}
  ,{Name: "Starfruit", Image: StarfruitImg, Seasons: ["Summer"], Sources: ["Farming"]}
  ,{Name: "Corn", Image: CornImg, Seasons: ["Summer","Fall"], Sources: ["Farming"]}
  ,{Name: "Unmilled Rice", Image: Unmilled_RiceImg, Seasons: ["Spring"], Sources: ["Farming"]}
  ,{Name: "Eggplant", Image: EggplantImg, Seasons: ["Fall"], Sources: ["Farming"]}
  ,{Name: "Artichoke", Image: ArtichokeImg, Seasons: ["Fall"], Sources: ["Farming"]}
  ,{Name: "Pumpkin", Image: PumpkinImg, Seasons: ["Fall"], Sources: ["Farming"]}
  ,{Name: "Bok Choy", Image: Bok_ChoyImg, Seasons: ["Fall"], Sources: ["Farming"]}
  ,{Name: "Yam", Image: YamImg, Seasons: ["Fall"], Sources: ["Farming"]}
  ,{Name: "Chanterelle", Image: ChanterelleImg, Seasons: ["Fall"], Sources: ["Foraging","Foraging"]}
  ,{Name: "Cranberries", Image: CranberriesImg, Seasons: ["Fall"], Sources: ["Farming"]}
  ,{Name: "Holly", Image: HollyImg, Seasons: ["Winter"], Sources: ["Foraging","Foraging"]}
  ,{Name: "Beet", Image: BeetImg, Seasons: ["Fall"], Sources: ["Farming"]}
  ,{Name: "Ostrich Egg", Image: Ostrich_EggImg, Seasons: [], Sources: ["Ostrich"]}
  ,{Name: "Salmonberry", Image: SalmonberryImg, Seasons: ["Spring"], Sources: ["Foraging","Foraging"]}
  ,{Name: "Amaranth", Image: AmaranthImg, Seasons: ["Fall"], Sources: ["Farming"]}
  ,{Name: "Pale Ale", Image: Pale_AleImg, Seasons: [], Sources: ["Keg+Hops"]}
  ,{Name: "Hops", Image: HopsImg, Seasons: ["Summer"], Sources: ["Farming"]}
  ,{Name: "Void Egg", Image: Void_EggImg, Seasons: [], Sources: ["Void Chicken","Krobus","Void Salmon"]}
  ,{Name: "Mayonnaise", Image: MayonnaiseImg, Seasons: [], Sources: ["Mayonnaise Machine+Egg"]}
  ,{Name: "Duck Mayonnaise", Image: Duck_MayonnaiseImg, Seasons: [], Sources: ["Mayonnaise Machine+Duck Egg"]}
  ,{Name: "Void Mayonnaise", Image: Void_MayonnaiseImg, Seasons: [], Sources: ["Mayonnaise Machine+Void Egg","Fishing","Witch's Swamp"]}
  ,{Name: "Clay", Image: ClayImg, Seasons: [], Sources: ["Artifact Spot"]}
  ,{Name: "Copper Bar", Image: Copper_BarImg, Seasons: [], Sources: ["Furnace","Foraging"]}
  ,{Name: "Iron Bar", Image: Iron_BarImg, Seasons: [], Sources: ["Crafting","Furnace","Foraging"]}
  ,{Name: "Gold Bar", Image: Gold_BarImg, Seasons: [], Sources: ["Crafting","Furnace","The Mines"]}
  ,{Name: "Iridium Bar", Image: Iridium_BarImg, Seasons: [], Sources: ["Furnace"]}
  ,{Name: "Refined Quartz", Image: Refined_QuartzImg, Seasons: [], Sources: ["Furnace","Foraging"]}
  ,{Name: "Honey", Image: HoneyImg, Seasons: ["Spring","Summer","Fall"], Sources: ["Bee House","Oasis"]}
  ,{Name: "Pickles", Image: PicklesImg, Seasons: [], Sources: []}
  ,{Name: "Jelly", Image: JellyImg, Seasons: [], Sources: []}
  ,{Name: "Beer", Image: BeerImg, Seasons: [], Sources: ["Keg+Wheat"]}
  ,{Name: "Wine", Image: WineImg, Seasons: [], Sources: ["Keg"]}
  ,{Name: "Juice", Image: JuiceImg, Seasons: [], Sources: ["Keg"]}
  ,{Name: "Clam", Image: ClamImg, Seasons: [], Sources: ["Foraging"]}
  ,{Name: "Poppy", Image: PoppyImg, Seasons: ["Summer"], Sources: ["Farming"]}
  ,{Name: "Copper Ore", Image: Copper_OreImg, Seasons: [], Sources: ["The Mines","Blacksmith","Artifact Spot","Traveling Cart"]}
  ,{Name: "Iron Ore", Image: Iron_OreImg, Seasons: [], Sources: ["Blacksmith","Fishing","Traveling Cart"]}
  ,{Name: "Coal", Image: CoalImg, Seasons: [], Sources: ["Blacksmith","Charcoal Kiln","Recycling Machine","Artifact Spot","Traveling Cart","Foraging"]}
  ,{Name: "Gold Ore", Image: Gold_OreImg, Seasons: [], Sources: ["Mining","Blacksmith","Fishing","Frozen Geode","Magma Geode","Omni Geode","Traveling Cart","Lava Eel","Fish Pond"]}
  ,{Name: "Iridium Ore", Image: Iridium_OreImg, Seasons: [], Sources: ["Skull Cavern","Statue Of Perfection","Magma Geode","Omni Geode","Super Cucumber","Fish Pond","Traveling Cart"]}
  ,{Name: "Wood", Image: WoodImg, Seasons: [], Sources: ["Trees","Carpenter's Shop","Foraging"]}
  ,{Name: "Stone", Image: StoneImg, Seasons: [], Sources: ["Carpenter's Shop","Foraging"]}
  ,{Name: "Nautilus Shell", Image: Nautilus_ShellImg, Seasons: ["Winter"], Sources: ["Foraging","Foraging"]}
  ,{Name: "Coral", Image: CoralImg, Seasons: [], Sources: ["Foraging","Foraging"]}
  ,{Name: "Rainbow Shell", Image: Rainbow_ShellImg, Seasons: ["Summer"], Sources: ["Foraging","Foraging"]}
  ,{Name: "Spice Berry", Image: Spice_BerryImg, Seasons: ["Summer"], Sources: ["Foraging","Summer Seeds","Foraging"]}
  ,{Name: "Sea Urchin", Image: Sea_UrchinImg, Seasons: [], Sources: ["Foraging","Foraging"]}
  ,{Name: "Grape", Image: GrapeImg, Seasons: ["Summer","Fall"], Sources: ["Foraging","Farming","Foraging","Farming"]}
  ,{Name: "Spring Onion", Image: Spring_OnionImg, Seasons: ["Spring"], Sources: ["Foraging","Foraging"]}
  ,{Name: "Strawberry", Image: StrawberryImg, Seasons: ["Spring"], Sources: ["Farming"]}
  ,{Name: "Sweet Pea", Image: Sweet_PeaImg, Seasons: ["Summer"], Sources: ["Foraging","Summer Seeds","Foraging"]}
  ,{Name: "Common Mushroom", Image: Common_MushroomImg, Seasons: ["Spring","Fall"], Sources: ["Foraging","Fall Seeds","Foraging"]}
  ,{Name: "Wild Plum", Image: Wild_PlumImg, Seasons: ["Fall"], Sources: ["Foraging","Fall Seeds","Foraging"]}
  ,{Name: "Hazelnut", Image: HazelnutImg, Seasons: ["Fall"], Sources: ["Foraging","Fall Seeds","Foraging"]}
  ,{Name: "Blackberry", Image: BlackberryImg, Seasons: ["Fall"], Sources: ["Foraging","Fall Seeds","Foraging"]}
  ,{Name: "Winter Root", Image: Winter_RootImg, Seasons: ["Winter"], Sources: ["Winter Seeds","Foraging"]}
  ,{Name: "Crystal Fruit", Image: Crystal_FruitImg, Seasons: ["Winter"], Sources: ["Foraging","Winter Seeds","Dust Sprite","Foraging"]}
  ,{Name: "Snow Yam", Image: Snow_YamImg, Seasons: ["Winter"], Sources: ["Winter Seeds","Foraging"]}
  ,{Name: "Sweet Gem Berry", Image: Sweet_Gem_BerryImg, Seasons: ["Fall"], Sources: ["Farming"]}
  ,{Name: "Crocus", Image: CrocusImg, Seasons: ["Winter"], Sources: ["Foraging","Winter Seeds","Foraging"]}
  ,{Name: "Red Mushroom", Image: Red_MushroomImg, Seasons: ["Summer"], Sources: ["Foraging","Mushroom Tree","Foraging"]}
  ,{Name: "Sunflower", Image: SunflowerImg, Seasons: ["Summer","Fall"], Sources: ["Farming"]}
  ,{Name: "Purple Mushroom", Image: Purple_MushroomImg, Seasons: [], Sources: ["The Mines","The Cave","Mushroom Tree","Foraging"]}
  ,{Name: "Cheese", Image: CheeseImg, Seasons: [], Sources: ["Cheese Press+Milk","Desert Trader"]}
  ,{Name: "Goat Cheese", Image: Goat_CheeseImg, Seasons: [], Sources: ["Cheese Press+Goat Milk"]}
  ,{Name: "Cloth", Image: ClothImg, Seasons: [], Sources: ["Loom+Wool","Mummy","Desert Trader"]}
  ,{Name: "Truffle", Image: TruffleImg, Seasons: ["Spring","Summer","Fall"], Sources: ["Pig","Foraging"]}
  ,{Name: "Truffle Oil", Image: Truffle_OilImg, Seasons: [], Sources: ["Oil Maker+Truffle"]}
  ,{Name: "Coffee Bean", Image: Coffee_BeanImg, Seasons: ["Spring","Summer"], Sources: ["Dust Sprite","Traveling Cart","Farming"]}
  ,{Name: "Goat Milk", Image: Goat_MilkImg, Seasons: [], Sources: ["Goat"]}
  ,{Name: "Large Goat Milk", Image: Large_Goat_MilkImg, Seasons: [], Sources: ["Goat"]}
  ,{Name: "Wool", Image: WoolImg, Seasons: [], Sources: ["Rabbit","Sheep"]}
  ,{Name: "Duck Egg", Image: Duck_EggImg, Seasons: [], Sources: ["Duck"]}
  ,{Name: "Duck Feather", Image: Duck_FeatherImg, Seasons: [], Sources: ["Duck","Traveling Cart"]}
  ,{Name: "Caviar", Image: CaviarImg, Seasons: [], Sources: ["Preserves Jar+Sturgeon Roe"]}
  ,{Name: "Rabbit's Foot", Image: Rabbits_FootImg, Seasons: [], Sources: ["Rabbit","Traveling Cart","Serpent"]}
  ,{Name: "Aged Roe", Image: Aged_RoeImg, Seasons: [], Sources: ["Preserves Jar+Roe"]}
  ,{Name: "Ancient Fruit", Image: Ancient_FruitImg, Seasons: ["Spring","Summer","Fall"], Sources: ["Farming"]}
  ,{Name: "Mead", Image: MeadImg, Seasons: [], Sources: ["Keg+Honey"]}
  ,{Name: "Tulip", Image: TulipImg, Seasons: ["Spring"], Sources: ["Farming"]}
  ,{Name: "Summer Spangle", Image: Summer_SpangleImg, Seasons: ["Summer"], Sources: ["Farming"]}
  ,{Name: "Fairy Rose", Image: Fairy_RoseImg, Seasons: ["Fall"], Sources: ["Farming"]}
  ,{Name: "Blue Jazz", Image: Blue_JazzImg, Seasons: ["Spring"], Sources: ["Farming"]}
  ,{Name: "Apple", Image: AppleImg, Seasons: ["Fall"], Sources: ["Apple Tree","Farming"]}
  ,{Name: "Green Tea", Image: Green_TeaImg, Seasons: [], Sources: ["Keg+Tea Leaves"]}
  ,{Name: "Apricot", Image: ApricotImg, Seasons: ["Spring"], Sources: ["Apricot Tree","Farming"]}
  ,{Name: "Orange", Image: OrangeImg, Seasons: ["Summer"], Sources: ["Orange Tree","Farming"]}
  ,{Name: "Peach", Image: PeachImg, Seasons: ["Summer"], Sources: ["Peach Tree","Farming"]}
  ,{Name: "Pomegranate", Image: PomegranateImg, Seasons: ["Fall"], Sources: ["Pomegranate Tree","Farming"]}
  ,{Name: "Cherry", Image: CherryImg, Seasons: ["Spring"], Sources: ["Cherry Tree","Farming"]}
  ,{Name: "Bug Meat", Image: Bug_MeatImg, Seasons: [], Sources: []}
  ,{Name: "Hardwood", Image: HardwoodImg, Seasons: [], Sources: ["Foraging","Fish Pond","Mahogany Tree","Foraging"]}
  ,{Name: "Maple Syrup", Image: Maple_SyrupImg, Seasons: [], Sources: ["Crafting","Tapper","Foraging"]}
  ,{Name: "Oak Resin", Image: Oak_ResinImg, Seasons: [], Sources: ["Tapper","Foraging"]}
  ,{Name: "Pine Tar", Image: Pine_TarImg, Seasons: [], Sources: ["Crafting","Tapper","Foraging"]}
  ,{Name: "Slime", Image: SlimeImg, Seasons: [], Sources: ["Slimes","Krobus","Slime Ball","Traveling Cart","Fish Pond"]}
  ,{Name: "Bat Wing", Image: Bat_WingImg, Seasons: [], Sources: ["Foraging"]}
  ,{Name: "Solar Essence", Image: Solar_EssenceImg, Seasons: [], Sources: ["Fish Pond"]}
  ,{Name: "Void Essence", Image: Void_EssenceImg, Seasons: [], Sources: ["Fish Pond"]}
  ,{Name: "Fiber", Image: FiberImg, Seasons: [], Sources: ["Foraging","Farming"]}
  ,{Name: "Battery Pack", Image: Battery_PackImg, Seasons: [], Sources: ["Lightning Rod","Solar Panel"]}
  ,{Name: "Dinosaur Mayonnaise", Image: Dinosaur_MayonnaiseImg, Seasons: [], Sources: ["Mayonnaise Machine"]}
  ,{Name: "Roe", Image: RoeImg, Seasons: [], Sources: ["Fish Pond"]}
  ,{Name: "Squid Ink", Image: Squid_InkImg, Seasons: [], Sources: ["Fish Pond","Fish Pond"]}
  ,{Name: "Tea Leaves", Image: Tea_LeavesImg, Seasons: ["Spring","Summer","Fall"], Sources: ["Farming"]}
  ,{Name: "Ginger", Image: GingerImg, Seasons: [], Sources: ["Foraging"]}
  ,{Name: "Taro Root", Image: Taro_RootImg, Seasons: ["Summer"], Sources: ["Farming"]}
  ,{Name: "Pineapple", Image: PineappleImg, Seasons: ["Summer"], Sources: ["Farming"]}
  ,{Name: "Mango", Image: MangoImg, Seasons: ["Summer"], Sources: ["Mango Tree","Farming"]}
  ,{Name: "Cinder Shard", Image: Cinder_ShardImg, Seasons: [], Sources: ["Volcano Dungeon","Stingray","Fish Pond"]}
  ,{Name: "Magma Cap", Image: Magma_CapImg, Seasons: [], Sources: ["Foraging","False Magma Cap","Stingray","Fish Pond","Foraging"]}
  ,{Name: "Bone Fragment", Image: Bone_FragmentImg, Seasons: [], Sources: ["Skeleton","Lava Lurk","Artifact Spot","Skull Cavern"]}
  ,{Name: "Radioactive Ore", Image: Radioactive_OreImg, Seasons: [], Sources: ["The Mines","Skull Cavern"]}
  ,{Name: "Radioactive Bar", Image: Radioactive_BarImg, Seasons: [], Sources: ["Furnace"]}
  ]